var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLaunchingIcon5(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 145.721,
    height: 128.121,
    viewBox: "0 0 145.721 128.121",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "heart",
    d: "M128.651,13.618a36.237,36.237,0,0,0-51.259,0L70.408,20.6l-6.984-6.984A36.246,36.246,0,0,0,12.165,64.877l6.984,6.984L70.408,123.12l51.259-51.259,6.984-6.984a36.237,36.237,0,0,0,0-51.259Z",
    transform: "translate(2.451 1.002)",
    fill: "none",
    stroke: "#cb39bd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunchingIcon5);
export default __webpack_public_path__ + "static/media/launching-icon5.4ae436159bbadc33c0f2f076e2988e1c.svg";
export { ForwardRef as ReactComponent };